import { Modal, ModalProps } from 'antd';
import { useTranslate } from '@tolgee/react';
import ShopeeVoucherForm from './ShopeeVoucherForm';
import LazadaVoucherForm from './LazadaVoucherForm';
import { VoucherBody } from 'services/api/voucher';
import { useForm } from 'antd/lib/form/Form';
import { useVoucherFormSubmit } from './useVoucherFormSubmit';
import { useMemoizedFn } from 'ahooks';

interface VoucherModalProps extends ModalProps {
  storeId: Conversation.Conversation['storeId'];
  storeName: string;
  platform: General.PlatformUpperCase;
  region: General.UpperCaseRegion;
  onSuccess?: () => void;
}

export const VoucherModal = (props: VoucherModalProps) => {
  const { storeId, region, storeName, platform, onSuccess, ...rest } = props;
  const { t } = useTranslate();
  const [form] = useForm<VoucherBody>();
  const { dynamicRules, submitLoading, submitCreateFormValues } = useVoucherFormSubmit();

  const submit = useMemoizedFn(async (values: any) => {
    const result = await submitCreateFormValues(values, storeId, platform);
    if (result) {
      onSuccess?.();
    }
  });

  return (
    <Modal
      {...rest}
      bodyStyle={{ padding: 0, height: '600px', overflowY: 'auto' }}
      destroyOnClose
      okButtonProps={{
        title: t('common.action.save'),
        loading: submitLoading,
        onClick: form.submit,
      }}
    >
      <div className="h-[36px] leading-[36px] px-4 bg-[#F7F9FA] mb-4">
        {t('coupon.field.shopName')}: {storeName}
      </div>
      <div className="px-4">
        {platform === 'SHOPEE' && (
          <ShopeeVoucherForm
            storeId={storeId}
            region={region}
            form={form}
            disableCache
            onFinish={submit}
          />
        )}
        {platform === 'LAZADA' && (
          <LazadaVoucherForm
            storeId={storeId}
            region={region}
            form={form}
            dynamicRules={dynamicRules}
            disableCache
            onFinish={submit}
          />
        )}
      </div>
    </Modal>
  );
};
